export default __webpack_public_path__ + "locales/lo-LA/DowngradePlanDialog.json?hash=983c5b332217fa91d772882d1e5748b3";